import React, { useMemo } from "react";
import { Block, useStyletron, CoinsStacked02 } from "@mezo-org/mezo-clay";
import ListingItem from "../ListingItem";
import { formatUsd } from "../../../utils/currency";
export default function AccountOtherAssets(props) {
    const { assetsCount, assetsUsdTotal, onClick } = props;
    const [, theme] = useStyletron();
    const label = useMemo(() => {
        if (assetsCount === 0)
            return "No other assets";
        if (assetsCount === 1)
            return "1 more asset";
        return `${assetsCount} more assets`;
    }, [assetsCount]);
    const formattedAssetsUsdTotal = formatUsd(assetsUsdTotal);
    return (React.createElement(Block, { "aria-label": label, as: "li", overrides: {
            Block: {
                style: {
                    listStyle: "none",
                    borderTop: `1px solid ${theme.colors.borderInverseSelected}`,
                },
            },
        } },
        React.createElement(ListingItem, { icon: CoinsStacked02, label: label, value: formattedAssetsUsdTotal, overrides: {
                Root: {
                    props: {
                        $as: "button",
                        onClick,
                    },
                    style: {
                        border: 0,
                        padding: 0,
                        cursor: "pointer",
                    },
                },
                ArtworkContainer: {
                    style: {
                        stroke: theme.colors.contentPrimary,
                    },
                },
                Content: {
                    style: {
                        minHeight: theme.sizing.scale1200,
                    },
                },
            } })));
}
//# sourceMappingURL=AccountOtherAssets.js.map